/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const organizationRequestOrganizationNameMin = 2;
export const organizationRequestOrganizationNameMax = 100;

export const OrganizationRequest = zod
	.object({
		organization: zod.object({
			name: zod
				.string()
				.min(organizationRequestOrganizationNameMin)
				.max(organizationRequestOrganizationNameMax)
				.optional()
				.describe('Organization name')
		})
	})
	.describe('Create or update organization request');

export type OrganizationRequest = zod.input<typeof OrganizationRequest>;
export type OrganizationRequestOutput = zod.output<typeof OrganizationRequest>;
